import { Component } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { DailyWageReportService } from './../../services/dailywagesreport.service';
import { LoaddingService } from './../../providers/loadding.service';
import { StorageService } from './../../providers/storage.service';
import { PageDefault } from './../../pages/PageDefault';
import { UserModel } from './../../models/user.model';
import { DailyWageSearch } from './dailywagesearch';

/*
    日工资报表
    TQQ 2016-12-28
*/
@Component({
    selector: "dailywagesreport",
    templateUrl: "dailywagesreport.html",
    providers: [
        DailyWageReportService
    ]
})
export class DailyWagesReport {
    constructor(
        private dailywagesreport: DailyWageReportService,
        private loadding: LoaddingService,
        private storage: StorageService,
        private modalCtrl: ModalController
    ) { }

    modelList = [];
    username = this.storage.read<UserModel>("User").UserName;
    isHave = true;
    paras = new DailyWageReportInput();
    time = new Date();
    excludeTracks = [];
    hasmore: boolean = false;
    teamFlag:boolean=false;
    ionViewDidLoad() {
        let load = this.loadding.showLoding();      
        this.getDailywageReport(this.paras).then(s => {
            this.loadding.closeLoading(load);
        });
    }

    //下拉重新加载
    //TQQ 2017-01-03
    doRefresh(refresher) {
        this.paras.PageIndex = 1;
        if(!this.teamFlag){
            this.getDailywageReport(this.paras).then(s => {
            refresher.complete();
        });
        }else{
            this.getTeamDailywageReport(this.paras).then(s=>{
                refresher.complete();
            });
        }
        
    }

    //上拉获取下一页信息
    //TQQ 2017-01-03
    doInfinite(infiniteScroll) {
        this.paras.PageIndex++;
        if(!this.teamFlag){
            this.getDailywageReport(this.paras,).then(s => {
                infiniteScroll.complete();
            });
        }else{
            this.getTeamDailywageReport(this.paras).then(s=>{
                infiniteScroll.complete();
            });
        }
        
    }

    //查询条件
    //TQQ 2017-01-03
    presentFilter() {
        let modal = this.modalCtrl.create(DailyWageSearch, this.excludeTracks);
        modal.present();
        modal.onWillDismiss((data: any[]) => {
            if (data) {
                this.excludeTracks = data;
                
                this.paras.StartDate = this.excludeTracks["startDate"];
                this.paras.EndDate = this.excludeTracks["endDate"];
                // this.paras.type = this.excludeTracks["type"];               
                //  this.paras.PageIndex=this.excludeTracks["PageIndex"];
                if(this.excludeTracks["type"]=="0"){
                    this.teamFlag=false;                                     
                    this.getDailywageReport(this.paras);
                }else{
                    this.teamFlag=true;
                    this.paras.subUserName = this.excludeTracks["subUserName"];
                    this.getTeamDailywageReport(this.paras);
                }
                
            }
        });
    }

    //获取常规投注信息
    //TQQ 2016-12-30
    getDailywageReport(input: DailyWageReportInput) {
        return this.dailywagesreport.getDailyWagesReports(input.StartDate, input.EndDate, input.PageIndex, input.PageSize).then(s => {
            if (input.PageIndex == 1) {
                this.modelList = [];
                this.modelList = s.List;
                if (s.List.length < s.PageCount) {
                    this.hasmore = true;
                } else {
                    this.hasmore = false;
                }
            } else {
                this.modelList = this.modelList.concat(s.List);
                if (this.modelList.length < s.PageCount) {
                    this.hasmore = true;
                }
                else {
                    input.PageIndex = 1;
                    this.hasmore = false;
                }
            }
            if (this.modelList == null || this.modelList.length < 1) {
                this.isHave = false;
            } else {
                this.isHave = true;
            }
        });
        
    }
    //获取团队日工资报表
    getTeamDailywageReport(input: DailyWageReportInput){
        return this.dailywagesreport.getSubUserDailyWagesReports(input.subUserName,input.StartDate, input.EndDate, input.PageIndex, input.PageSize).then(s => {
            if (input.PageIndex == 1) {
                this.modelList = [];
                this.modelList = s.List;
                if (s.List.length < s.PageCount) {
                    this.hasmore = true;
                } else {
                    this.hasmore = false;
                }
            } else {
                this.modelList = this.modelList.concat(s.List);
                if (this.modelList.length < s.PageCount) {
                    this.hasmore = true;
                }
                else {
                    input.PageIndex = 1;
                    this.hasmore = false;
                }
            }
            if (this.modelList == null || this.modelList.length < 1) {
                this.isHave = false;
            } else {
                this.isHave = true;
            }
        }); 
    }
}

export class DailyWageReportInput {
    StartDate: string = PageDefault.endNowDate();
    EndDate: string = PageDefault.endDate();
    PageIndex: number = 1;
    PageSize: number = PageDefault.PageSize();
    subUserName: string = "";
}




// WEBPACK FOOTER //
// ./src/pages/dailywagesreport/dailywagesreport.ts